import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
    },
    leftContainer: {
        height: '40px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    innerContainer: {
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        boxSizing: 'border-box',
    },
    blueBar: {
        height: '20px',
        width: '2px',
        backgroundColor: '#3F51B5',
    },
    labelText: {
        fontSize: '14px',
        fontWeight: '400',
        color: '#5F6071',
        fontStyle: 'normal',
        lineHeight: '24px',
    },
    valueText: {
        fontSize: '14px',
        fontWeight: '400',
        color: '#2B2C35',
        fontStyle: 'normal',
        lineHeight: '24px',
    },
    buttonContainer: {
        height: '35px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
    },
    exportButton: {
        backgroundColor: '#3F51B5',
        color: '#fff',
        border: '1px solid #3F51B5',
        borderRadius: '4px',
        height: '35px',
        padding: '12px',
        boxSizing: 'border-box',
    },
    auditTrailButton: {
        color: '#3F51B5',
        border: '1px solid #3F51B5',
        borderRadius: '4px',
        height: '35px',
        padding: '12px',
        boxSizing: 'border-box',
    },
    drawerPaper: {
        width: '960px',
    },
}));

export default useStyles;
